"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var different_svg_1 = __importDefault(require("../../../assets/icons/condicional/different.svg"));
var equal_svg_1 = __importDefault(require("../../../assets/icons/condicional/equal.svg"));
var less_equal_svg_1 = __importDefault(require("../../../assets/icons/condicional/less_equal.svg"));
var less_than_svg_1 = __importDefault(require("../../../assets/icons/condicional/less_than.svg"));
var more_equal_svg_1 = __importDefault(require("../../../assets/icons/condicional/more_equal.svg"));
var more_than_svg_1 = __importDefault(require("../../../assets/icons/condicional/more_than.svg"));
var percent_svg_1 = __importDefault(require("../../../assets/icons/condicional/percent.svg"));
var percent_double_svg_1 = __importDefault(require("../../../assets/icons/condicional/percent_double.svg"));
var filter_alt_svg_1 = __importDefault(require("../../../assets/icons/condicional/filter_alt.svg"));
var filter_alt_off_svg_1 = __importDefault(require("../../../assets/icons/condicional/filter_alt_off.svg"));
var Condicional = {
    "<>": different_svg_1.default,
    "=": equal_svg_1.default,
    "<=": less_equal_svg_1.default,
    "<": less_than_svg_1.default,
    ">=": more_equal_svg_1.default,
    ">": more_than_svg_1.default,
    "%": percent_svg_1.default,
    "%%": percent_double_svg_1.default,
    "in": filter_alt_svg_1.default,
    "not_in": filter_alt_off_svg_1.default
};
exports.default = Condicional;
